import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const serviceId = 3
const slug = 'industrial-footings-excavation';
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: `Industrial Footings Excavation | ${BUSINESS_NAME}`,
        description: "Heavy-duty footing excavation for factories, warehouses, and commercial structures, completed with safety and accuracy.",
        keywords: "heavy-duty footing excavation, industrial footings, commercial footings, factory footings, warehouse footings, site preparation, earthmoving, soil removal, foundation excavation, retaining wall excavation, structural support, residential footings, custom footing design, construction project management, sydney builders",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Industrial Footings Excavation',
    description: 'Heavy-duty footing excavation for factories, warehouses, and commercial structures, completed with safety and accuracy.',
    points: [
    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
